import styled from 'styled-components';


/*
========================================
CONTENEDOR
========================================
*/

export const ContenedorUbicacion =
    styled.div`

    width: 100%;

    box-sizing: border-box;

    margin-top: 1rem;

    margin-bottom: 1.5rem;
`;


/*
========================================
GRID
========================================
*/

export const GridUbicacion =
    styled.div`

    display: grid;

    grid-template-columns:
        repeat(
            2,
            minmax(0, 1fr)
        );

    gap:
        1rem
        1.2rem;

    margin-top: 1rem;


    @media (max-width: 700px) {

        grid-template-columns:
            1fr;
    }
`;


/*
========================================
CAMPO
========================================
*/

export const CampoUbicacion =
    styled.div`

    display: flex;

    flex-direction: column;

    gap: 0.35rem;
`;


/*
========================================
LABEL
========================================
*/

export const LabelUbicacion =
    styled.label`

    font-size: 0.8rem;

    font-weight: 600;

    color: #2B2B2B;
`;


/*
========================================
SELECT
========================================
*/

export const SelectUbicacion =
    styled.select`

    width: 100%;

    height: 40px;

    box-sizing: border-box;

    padding:
        0
        0.75rem;

    border:
        1px solid
        #D8D8D4;

    border-radius: 8px;

    outline: none;

    background-color: #FFFFFF;

    font-family: inherit;

    font-size: 0.88rem;

    color: #2B2B2B;


    &:focus {

        border-color: #23AAAF;
    }


    &:disabled {

        background-color: #F4F4F2;

        color: #888888;

        cursor: not-allowed;
    }


    &[aria-invalid="true"] {

        border-color: #D76970;
    }
`;


/*
========================================
INPUT
========================================
*/

export const InputUbicacion =
    styled.input`

    width: 100%;

    height: 40px;

    box-sizing: border-box;

    padding:
        0
        0.75rem;

    border:
        1px solid
        #D8D8D4;

    border-radius: 8px;

    outline: none;

    background-color: #FFFFFF;

    font-family: inherit;

    font-size: 0.88rem;

    color: #2B2B2B;


    &:focus {

        border-color: #23AAAF;
    }


    &:disabled {

        background-color: #F4F4F2;

        color: #888888;

        cursor: not-allowed;
    }


    &[aria-invalid="true"] {

        border-color: #D76970;
    }
`;


/*
========================================
TEXTO DE AYUDA
========================================
*/

export const TextoAyudaUbicacion =
    styled.div`

    margin-top: 0.65rem;

    font-size: 0.72rem;

    line-height: 1.4;

    color: #646464;
`;


/*
========================================
CARGANDO
========================================
*/

export const TextoCargaUbicacion =
    styled.div`

    min-height: 14px;

    font-size: 0.7rem;

    color: #646464;
`;


/*
========================================
ERROR
========================================
*/

export const MensajeErrorUbicacion =
    styled.div`

    margin-top: 0.6rem;

    font-size: 0.75rem;

    line-height: 1.4;

    color: #D76970;
`;